<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import { ConfigModule } from "@/store/modules/config";
import { MAX_DOCUMENT_UPLOAD_SIZE_MB, megabytesToBytes } from "@/lib/constants/upload.constants";
import { $t } from "@/lib/utility/t";

@Component({})
export default class DragMixin extends Vue {
  maxFileSizeInMb = 5;

  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  onDrop(file: File): void {
    this.isFailed = true;
    throw new Error("No event handler for drop implemented");
  }

  isDrag = false;

  isDrop = false;

  isFailed = false;

  acceptFile = true;

  acceptImage = true;

  dragOver() {
    this.isDrag = true;

    // force stop dragging animation after 5 seconds, because the ui can reach an unusable state e.g. if backend call fails unexpectedly and is not handled
    setTimeout(() => {
      this.isDrag = false;
      this.isDrop = false;
      this.isFailed = false;
    }, 5000);
  }

  dragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (!event.relatedTarget || !(event.currentTarget as any)?.contains(event.relatedTarget)) {
      this.isDrag = false;
    }
  }

  onFileDrop(event: DragEvent) {
    const files = event.dataTransfer?.files;
    if (!files) {
      return;
    }
    const file = files[0];
    if (!file) {
      this.isDrop = false;
      return;
    }

    this.isDrop = true;

    const isPDF = ConfigModule.pdfInputTypes.includes(file.type);
    const isImage = ConfigModule.imageInputTypes.includes(file.type);
    const maxSizeInMb = isPDF ? MAX_DOCUMENT_UPLOAD_SIZE_MB : this.maxFileSizeInMb;
    const isTooLarge = file.size > megabytesToBytes(maxSizeInMb);

    if (isTooLarge) {
      this.$toast.error(this.$t("sign.ReportDocumentSignRequestForm.maxSize", { size: maxSizeInMb }));
      this.isFailed = true;
    } else if (!this.acceptFile && isPDF && !isImage) {
      this.$toast.error($t("components.DropField.pdfsNotAllowed"));
      this.isFailed = true;
    } else if (!this.acceptImage && isImage) {
      this.$toast.error($t("components.DropField.imagesNotAllowed"));
      this.isFailed = true;
    } else if (!isPDF && !isImage) {
      this.$toast.error($t("components.DropField.filesNotAllowed"));
      this.isFailed = true;
    } else {
      this.onDrop(file);
    }

    setTimeout(() => {
      this.isDrag = false;
      this.isDrop = false;
      this.isFailed = false;
    }, 1000);
  }
}
</script>

<style scoped>
.drag {
  border-radius: 5px;
  position: absolute;
  z-index: 1;
  background-color: rgba(1, 1, 1, 0.3);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fade {
  animation: fade 1s ease-out;
}
.fadeIn {
  animation: appear 0.5s;
}

@keyframes appear {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fade {
  0% {
    opacity: 0.5;
    transform: scale(0.9);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.9);
  }
}
</style>
